import { Alert } from "antd";
import { renderInlineMarkdown } from "./inlineMd";

interface CalloutBlockProps {
	kind: "info" | "warning" | "success";
	text: string;
}

export default function CalloutBlock({ kind, text }: CalloutBlockProps) {
	return (
		<Alert
			type={kind}
			message={renderInlineMarkdown(text)}
			showIcon
			style={{ marginBottom: 12 }}
		/>
	);
}
